import { FC, ReactElement } from 'react'

import { SvgIconProps } from '../Icon'

const IconFileUpload: FC<SvgIconProps> = ({ className = '' }): ReactElement => (
    <svg className={`icon-component ${className}`} viewBox="0 0 24 24">
        <path d="M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z" />
    </svg>
)

export default IconFileUpload
